const Level = {

    // FIELDS
    "name": "Name",
    "search": "Search",

    // PAGE HEADER
    "level": "Level",
    "levels": "Levels",

    // ERROR
    "error_name": "Enter Name",

    // BUTTON
    "add_level": "Add Level",

    // TABLE HEADER

}

export default Level;